import React from 'react';

const aboutContent = [
    {
        headerImg: <img alt='' src={require('../assets/images/pic-st6.jpg')}/>,
        textContent: [
            {
                bgIconClass: 'bg-orange',
                headerIcon: <img alt='' src={require('../assets/images/tick-inside-circle.svg')}/>,
                title: {fa: 'تاریخچه ', en: 'History'},
                description: {
                    fa: <span>
                        <span>شرکت پردازش اطلاعات مالی مفید در تاریخ ۱۳۸۷/۰۷/۰۱ به صورت شرکت با مسئولیت محدود تاسیس شده و طی شماره ۳۵۴۹۸۳ در اداره ثبت شرکتها و مالکیت صنعتی تهران به ثبت رسیده است. آخرین سرمایه ثبت شده شرکت ۱۲۰ میلیارد ریال است.</span>
                        <br/>
                        <br/>
                        {/*<br/>*/}
                        {/*<ol>*/}
                        {/*    <li>شخص حقوقی (گروه خدمات بازار سرمایه مفید): </li>*/}
                        {/*    <li>شخص حقیقی:</li>*/}
                        {/*    <b>-</b><span>محمد مهدی سیف اللهی (مدیر عامل و عضو هیات مدیره) -%1.66- کارشناسی</span>*/}
                        {/*    <li>شخص حقیقی:</li>*/}
                        {/*    <b>-</b><span>رسول وفائی (نایب رئیس هیات مدیره) -%1.66- کارشناسی</span>*/}
                        {/*</ol>*/}
                        <b>اعضای هیات مدیره شرکت پردازش اطلاعات مالی مفید: </b>
                        <br/>
                        <table className='about-table'>
                            <tr>
                                <th>ردیف</th>
                                <th>نام</th>
                                <th>سمت</th>
                                {/* <th>درصد سهام</th> */}
                                <th>توضیحات</th>
                            </tr>
                            <tr>
                                <td>۱</td>
                                <td>رسول وفایی</td>
                                <td>رئیس هیات مدیره</td>
                                {/* <td>۹۳.۳۳%</td> */}
                                <td>نماینده گروه خدمات بازار سرمایه مفید</td>
                            </tr>
                            <tr>
                                <td>۲</td>
                                <td>سید احسان آدمن</td>
                                <td>نائب رئیس هیات مدیره </td>
                                {/* <td>۱.۶۶%</td> */}
                                <td>نماینده مشاور سرمایه گذاری ایده مفید</td>
                            </tr>
                            <tr>
                                <td>۳</td>
                                <td>مجتبی فخاری</td>
                                <td>مدیر عامل و عضو هیات مدیره</td>
                                {/* <td>۱.۶۶%</td> */}
                                <td>نماینده کارگزاری مفید</td>
                            </tr>
                            {/* <tr>
                                <td>۴</td>
                                <td>محمد مهدی سیف اللهی</td>
                                <td>حقیقی</td>
                                <td>۱.۶۶%</td>
                                <td>مدیر عامل و عضو هیات مدیره</td>
                            </tr>
                            <tr>
                                <td>۵</td>
                                <td>رسول وفائی</td>
                                <td>حقیقی</td>
                                <td>۱.۶۶%</td>
                                <td>نائب رئیس هیات مدیره</td>
                            </tr> */}
                        </table>
                        <br/>
                        <b>نمایندگان مجوز:</b>
                        <br/>
                        <table className='about-table'>
                            <tr>
                                <th>سمت سازمانی</th>
                                <th>نام شخص</th>
                            </tr>
                            <tr>
                                <td>نماینده مجوز-بایگان</td>
                                <td>سید محمد رضوی</td>
                            </tr>
                            <tr>
                                <td>نماینده مجوز-تحلیل گر</td>
                                <td>محمد جعفر بامودت</td>
                            </tr>
                            <tr>
                                <td>نماینده مجوز-کارشناس نرم افزار</td>
                                <td>فرید عرب</td>
                            </tr>
                            <tr>
                                <td>نماینده مجوز-حسابدار</td>
                                <td>مهران کاوه</td>
                            </tr>
                            <tr>
                                <td>نماینده مجوز-کارشناس مسئول بازبینی اطلاعات</td>
                                <td>محمد مهدی مستفید</td>
                            </tr>
                            <tr>
                                <td>نماینده مجوز-متصدی جمع آوری و ارائه اطلاعات</td>
                                <td>مجمد مسعود مرشدی</td>
                            </tr>
                        </table>
                        <br/>
                        {/* <ol>
                            <li>سید احسان آدمن: تحلیل‌گر - کارشناسی ارشد</li>
                            <li>محمد مهدی مستفید: کارشناس مسئول  بازبینی اطلاعات - کارشناسی</li>
                            <li>محمد مسعود مرشدی: متصدی جمع آوری و ارایه اطلاعات - کارشناسی</li>
                            <li>فرید عرب:‌ کارشناس نرم‌افزار - کارشناسی</li>
                            <li>سید محمد رضوی:‌ بایگان - کارشناسی</li>
                            <li>مهران کاوه:‌ حسابدار - کارشناسی</li>
                        </ol> */}
                        {/*<span>سید احسان آدمن، مجتبی فخاری، فرهاد ملک محمودی، حمیدرضا مردی، فرید عرب، مسعود صفا، علی صیفوری، علی محسنی، علی علیزاده، سید عرفان حنیفی. </span>*/}

                    </span>
                    ,
                    en: <span>
                        Pooya Growth Data Mining Company was established on 23-9-2009 as a limited company.the main center address is 6th Floor, Mofid Tower, Africa Blvd, Tehran 1589914511, Iran
                        <br/><br/>
                        the subject of the company's core business is provide information about stock market.
                    </span>
                },
            }
        ]
    },
    {
        headerImg: <img alt='' src={require('../assets/images/pic-st4.jpg')}/>,
        textContent: [
            {
                bgIconClass: 'bg-orange',
                headerIcon: <img alt='' src={require('../assets/images/tick-inside-circle.svg')}/>,
                title: {fa: 'عملکرد ', en: 'Performance'},
                description: {
                    fa: <span>شرکت پردازش اطلاعات مالی مفید به عنوان نخستین شرکت پردازش اطلاعات مالی از سازمان بورس اوراق بهادار مجوز پردازش اطلاعات مالی را در سال 1391 دریافت کرد. این شرکت با ترکیب متخصصان مالی و متخصصان فناوری اطلاعات در تلاش است ابزارهای مورد نیاز متخصصان حوزه مالی را تأمین کند. پس از معرفی سامانه بورس ویو به بازار سرمایه، ضمن مرتفع کردن نیاز بخشی از بازار، در مدت کوتاهی جایگاه و اعتبار مناسبی در میان فعالان بازار کسب کرد.</span>
                    ,
                    en: <span>Pooya Finance was the first financial information processing company to receive license in 2012. By combining financial and IT professionals, the company is working to provide the tools needed by Financial field pros. After introducing the Bourse View to stock market, it gained a good standing and credibility among market players in a short period of time.</span>
                },
            },
        ]
    },
    {
        headerImg: <img alt='' src={require('../assets/images/pic-st2.jpg')}/>,
        textContent: [
            {
                bgIconClass: 'bg-orange',
                headerIcon: <img alt='' src={require('../assets/images/tick-inside-circle.svg')}/>,
                title: {fa: 'راهبرد', en: 'Strategy'},
                description: {
                    fa: <span>با توجه به تغییرات سریع ارائه اطلاعات توسط شرکت ها و همچنین تغییر نحوه استفاده تحلیل گران از اطلاعات ارائه شده و افزایش عمق بازار سرمایه شرکت پردازش اطلاعات مالی مفید در سال 1396 با یک تغییر رویکرد اساسی در نحوه پردازش اطلاعات مالی برآن شد تا بخش های بکرتر بازار اطلاعات مالی را هدف قراردهد. در همین راستا و با کمک تیم قدرتمند فنی این شرکت کلیه دیتابیس ها و سرویس (API) های شرکت بازنویسی شدند و معماری مرکز داده شرکت تغییر کرد.<br/><br/> همچنین بادرنظر گرفتن تکنولوژی های روز پردازش اطلاعات مالی و با الگو برداری از پیشتازان این صنعت در دنیا تکنولوژی پردازش اطلاعات نیز از بستر Microsoft به تکنولوژی های پرکاربردتر و حرفه ای تر در جهان تغییر کرد. بعد از انجام این تغییرات بنیادین پروژه ایجاد Application تحت وب برای ارائه اطلاعات مالی پردازش شده در بستر قابل درک برای کاربران عادی (Web Browser) تحت عنوان بورس ویو به انجام رسید. </span>
                    ,
                    en: <span>Due to the rapid changes in the way companies provide information, as well as the way analysts use the information provided, the Pooya finance in 2016, has come up with a fundamental shift in the way financial information is processed to target more mature segments of the financial information market. With the help of its powerful technical team, all of the company's databases and services (APIs) were rewritten and the company's data center architecture changed.<br/><br/>Also, with the advent of cutting-edge financial information technologies and modeling the industry's pioneers in the world, information processing technology has also shifted from the Microsoft platform to the world's most used and professional technologies. After making these fundamental changes, the Web Application Development Project was launched to provide financial information processed in a context understandable to the Web Browser.</span>
                },
            },
        ]
    },

]


export default aboutContent;
